/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteClients = gql`
  mutation DeleteClients($ids: [ID!]!) {
    deleteClients(ids: $ids)
  }
`;
